import { createReducer, on } from '@ngrx/store';
import { initialExportState } from '../constants';
import { USER_EXPORT_ACTIONS } from '../actions';
import { OperationStatus } from '../types';

export const exportReducer = createReducer(
  initialExportState,
  on(USER_EXPORT_ACTIONS.initiateExport, (state) => ({
    ...state,
    status: 'initiated' as OperationStatus,
  })),
  on(USER_EXPORT_ACTIONS.exportStarted, (state, { status }) => ({
    ...state,
    status,
  })),
  on(USER_EXPORT_ACTIONS.exportSuccess, (state, { fileName, status }) => ({
    ...state,
    fileName,
    status,
  })),
  on(
    USER_EXPORT_ACTIONS.exportFailure,
    (state, { errorMessage, fileName, status }) => ({
      ...state,
      errorMessage,
      fileName,
      status,
    }),
  ),
  on(USER_EXPORT_ACTIONS.openExportConfirmationDialog, (state) => ({
    ...state,
    isDialogOpen: true,
  })),
  on(
    USER_EXPORT_ACTIONS.exportDialogConfirmed,
    USER_EXPORT_ACTIONS.exportDialogDismissed,
    (state) => ({
      ...state,
      isDialogOpen: false,
    }),
  ),
  on(
    USER_EXPORT_ACTIONS.onLoadDocumentExportsSuccess,
    (state, { exportsData }) => ({
      ...state,
      exportsData: { ...exportsData },
    }),
  ),
);
